import Swiper, { Autoplay, Navigation } from 'swiper';
import {swiperObserver} from "../../utils/swiper.utils.js";

document.querySelectorAll('.benefits-swiper-wr').forEach((el) => {
  const swiperEl = el.querySelector('.swiper');
  const nextEl = el.querySelector('.swiper-button-next');
  const prevEl = el.querySelector('.swiper-button-prev');

  if (!swiperEl) {
    return;
  }

  const slidesCount = swiperEl.querySelectorAll('.swiper-slide').length;
  const isDesktop = window.innerWidth >= 1024;
  const disableAutoplay = isDesktop && slidesCount === 3;
  const isTargetForInitialSlide = isDesktop && slidesCount >= 3;

  const autoplayConfig = disableAutoplay
    ? false
    : {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: window.innerWidth >= 1033,
      };

  let swiper = new Swiper(swiperEl, {
    modules: [Autoplay, Navigation],
    observer: true,
    observeParents: true,
    slidesPerView: 1,
    spaceBetween: 12,
    speed: 500,
    threshold: 10,
    initialSlide: isTargetForInitialSlide ? 1 : 0,
    allowTouchMove: !disableAutoplay,
    navigation: {
      nextEl,
      prevEl,
    },
    breakpoints: {
      389: {
        spaceBetween: 16,
      },
      641: {
        spaceBetween: 18,
      },
      961: {
        spaceBetween: 22,
      },
      1100: {
        spaceBetween: el.classList.contains('about-type') ? 23 : 32,
      },
      1200: {
        spaceBetween: el.classList.contains('about-type') ? 25 : 57,
      }
    },
    autoplay: autoplayConfig,
  });

  if (!disableAutoplay) {
    swiperObserver(swiper);
  }

  window.addEventListener('resize', () => {
    requestAnimationFrame(() => {
      const isDesktopNow = window.innerWidth >= 1024;
      const shouldDisableNow = isDesktopNow && slidesCount === 3;
      swiper.allowTouchMove = !shouldDisableNow;
      if (shouldDisableNow && swiper.autoplay && swiper.autoplay.running) {
        swiper.autoplay.stop();
      }
    });
  });

  const wrapper = swiperEl.querySelector('.swiper-wrapper');
  if (wrapper) {
    const decorator = document.createElement('div');
    decorator.classList.add('benefits-swiper-decorator');
    wrapper.appendChild(decorator);

    let frameId = null;
    const updateDecorator = () => {
      if (frameId) {
        return;
      }
      frameId = requestAnimationFrame(() => {
        frameId = null;
        const slides = swiper.slides;
        if (!slides || slides.length === 0) {
          return;
        }
        const first = slides[0];
        const last = slides[slides.length - 1];
        const start = first.offsetLeft + first.offsetWidth / 2;
        const end = last.offsetLeft + last.offsetWidth / 2;
        decorator.style.left = `${start}px`;
        decorator.style.width = `${end - start}px`;
      });
    };

    swiper.on('resize', updateDecorator);
    swiper.on('observerUpdate', updateDecorator);
    swiper.on('update', updateDecorator);
    updateDecorator();
  }
});
